import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ENV} from "../../../environments/environment";
import {CONSTANTS} from "../../../environments/common";

@Injectable({
  providedIn: 'root'
})
export class LanguagesService {

  constructor(private http: HttpClient) { }

  getCatalogueLanguages(catalogueId) {
    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE.GET_PROFILES + '/' + catalogueId + '/' + 'languages';
    return this.http.get(url);
  }

  getCatalogueDefaultLanguages(catalogueId) {
    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE.GET_PROFILES + '/' + catalogueId + '/' + 'languages/default';
    return this.http.get(url);
  }

  getRemoteCustomTranslationsJson(dataIn, local = false) {
    const time:number = Date.now();
    let urlMedia = ENV.MEDIA_REPOSITORY + '/ecatalogue/' + dataIn.sapCode + '/lang/' + dataIn.lang + '.json?t=' + time;
    return this.http.get(urlMedia);
  }

}
